import { dto_StartupPageLoadInfo } from "../../../../classes/dto-mobile-settings";
import { FORMAT_DECIMAL_VALUE } from "../../../../functions/funtion";
import { F_Fammily } from "../../../../util/config-fonts";

function PgProductPrice({ UD = Number, SP = Number }) {
  return (
    <div className="pgProductDesc">
      {UD > 0 ? (
        <div style={{ display: "flex" }}>
          <p
            style={{
              paddingTop: 0,
              margin: 0,
              fontFamily: F_Fammily.Medium,
              color: "red",
              alignSelf: "stretch",
              textDecorationLine: "line-through",
              textDecorationStyle: "solid",
              marginRight: 5,
            }}
          >
            {dto_StartupPageLoadInfo.Currency}
            {"  "}
            {FORMAT_DECIMAL_VALUE(2, SP, 2)}
          </p>
          <p
            style={{
              paddingTop: 0,
              color: "black",
              margin: 0,
              fontFamily: F_Fammily.Medium,
            }}
          >
            {dto_StartupPageLoadInfo.Currency}
            {"  "}
            {FORMAT_DECIMAL_VALUE(2, parseFloat(SP) - parseFloat(UD), 2)}
          </p>
        </div>
      ) : (
        <p
          style={{
            paddingTop: 0,
            color: "black",
            margin: 0,
            fontFamily: F_Fammily.Medium,
          }}
        >
          {dto_StartupPageLoadInfo.Currency}
          {"  "}
          {FORMAT_DECIMAL_VALUE(2, parseFloat(SP), 2)}
        </p>
      )}
    </div>
  );
}
export default PgProductPrice;
